import { IUsersInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const usersSelector = (state: RootState) => state.users;

const usersListSelector = createSelector([usersSelector], (users: IUsersInitialState) => users.usersList);

const userSelector = createSelector([usersSelector], (users: IUsersInitialState) => users.user);

export const usersSel = {
    usersSelector,
    userSelector,
    usersListSelector,
};
